import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconApplePodcastsStyle0 = cosmosIconCss;

const CosmosIconApplePodcasts$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconApplePodcasts extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '74f33ec80b8d498a440a83719fed957b2b8a1158', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd20b6eb21c8684cfe6636bc6669372aa76dc36aa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ebd3dc1f6fbc7eb7f489328b5dfb9cbb611e5a80', d: "M12.523 12.599c-.31-.328-.856-.538-1.5-.538-.643 0-1.188.21-1.499.537a.951.951 0 0 0-.274.596c-.053.484-.023.9.033 1.565.054.634.157 1.48.29 2.34.095.614.173.945.243 1.181.114.384.54.72 1.208.72.667 0 1.093-.336 1.207-.72.07-.236.148-.567.243-1.18.134-.861.236-1.707.29-2.34.057-.666.086-1.082.034-1.566a.95.95 0 0 0-.275-.596Zm-3.19-2.917a1.693 1.693 0 1 0 3.385 0 1.693 1.693 0 0 0-3.386 0ZM11.003 3c-3.96.011-7.204 3.224-7.253 7.184-.04 3.207 2.007 5.95 4.867 6.957a.097.097 0 0 0 .128-.106 41.6 41.6 0 0 1-.105-.746.25.25 0 0 0-.147-.197 6.353 6.353 0 0 1-3.813-5.879c.034-3.445 2.847-6.254 6.292-6.282a6.351 6.351 0 0 1 6.397 6.344 6.353 6.353 0 0 1-3.814 5.817.25.25 0 0 0-.146.198 41.69 41.69 0 0 1-.106.745c-.01.072.06.13.13.106 2.831-.996 4.867-3.698 4.867-6.866 0-4.018-3.276-7.286-7.297-7.275Zm-.131 3.338a3.947 3.947 0 0 1 4.098 3.94c0 1.131-.48 2.153-1.246 2.873a.301.301 0 0 0-.095.237c.016.27.01.534-.008.83-.005.08.084.13.15.086a4.872 4.872 0 0 0 2.13-4.027 4.88 4.88 0 0 0-5.066-4.87 4.888 4.888 0 0 0-4.68 4.807 4.872 4.872 0 0 0 2.13 4.09.096.096 0 0 0 .15-.085 6.977 6.977 0 0 1-.01-.831.302.302 0 0 0-.094-.237 3.932 3.932 0 0 1-1.245-2.98 3.954 3.954 0 0 1 3.786-3.833Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconApplePodcastsStyle0; }
}, [1, "cosmos-icon-apple-podcasts", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-apple-podcasts"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-apple-podcasts":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconApplePodcasts$1);
            }
            break;
    } });
}

const CosmosIconApplePodcasts = CosmosIconApplePodcasts$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconApplePodcasts, defineCustomElement };
